/**
 * @author Angel Labrada
 * @since v0.0.1
 * @date 16/1/22
 */
import React, {memo} from 'react';
import PropTypes from 'prop-types';
import styles from './index.less';
import {Tooltip, Typography} from 'antd';
import {useTranslation} from 'react-i18next';
const { Paragraph } = Typography;

const AuditOwnerCell = ({value}) => {
  const {t} = useTranslation('auditorAudits');

  return (
    <div className="flex items-center justify-start">
      <div className={'row-flex w-full'}>
        <Paragraph
          className={styles.detailTemplateParagraph}
          /* eslint-disable-next-line react/display-name */
          ellipsis={{tooltip: ()=>{
            return (
              <>
                <Tooltip placement="bottom">
                  {value?.fullName}
                </Tooltip>
              </>
            );
          }}}
        >
          <div className="flex items-center justify-start flex-wrap">
            <span style={{color: '#B2B2B2'}}>{t('createdBy')}:</span>
            <span>&nbsp;</span>
            <span>{value?.fullName}</span>
          </div>
        </Paragraph>
      </div>
    </div>
  );
};

AuditOwnerCell.propTypes = {
  value: PropTypes.object,
};
AuditOwnerCell.defaultProps = {
  entity: {},
};

export default memo(AuditOwnerCell);


/**
 * cellRender
 * */
/**
 * This is not a components,
 * it is a function to render the AuditEstablishmentCell components in a table cell
 * @param {string} value this is the row instance
 * */
export const renderAuditOwner = (value) => {

  return (
    <AuditOwnerCell value={value}/>
  );
};


